import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import lang from '@blade-sxp/portrait-management/lang/index';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import CombinedPicture from '@blade-sxp/portrait-management/components/combined-picture.vue';
import { Scale } from '@blade/common/utils/auto-scale';
let default_1 = class default_1 extends Vue {
    visible;
    data;
    form = {};
    get portraitMaxWidth() {
        return 240 * Scale;
    }
    get portraitMaxHeight() {
        return 240 * Scale;
    }
    /** 是否开启隐私模式 */
    get privacyMode() {
        return localStorage.getItem('privacyMode') === 'true';
    }
    get selfVisible() {
        return this.visible;
    }
    set selfVisible(val) {
        this.$emit('update:visible', val);
    }
    get allowSubmit() {
        return false;
    }
    cancelFunc() {
        this.selfVisible = false;
    }
    submitFunc() {
        this.selfVisible = false;
        this.$emit('submit', this.form);
    }
};
__decorate([
    Prop()
], default_1.prototype, "visible", void 0);
__decorate([
    Prop()
], default_1.prototype, "data", void 0);
default_1 = __decorate([
    Component({
        components: { BlurPicture, CombinedPicture },
        i18n: {
            messages: {
                en: {
                    ...lang.en,
                    add: 'Add',
                    distributedType: 'Distributed Type',
                    distributedTypeInputPlaceholder: 'Please select distributed type',
                    deliveryFailureDetails: 'Details of Delivery Failure ({count})',
                    failedAt: 'Failed At',
                    reason: 'Reason',
                },
                zh: {
                    ...lang.zh,
                    add: '添加',
                    distributedType: '下发类型',
                    distributedTypeInputPlaceholder: '请选择下发类型',
                    deliveryFailureDetails: '下发失败详情 ({count})',
                    failedAt: '失败时间',
                    reason: '原因',
                },
            },
        },
    })
], default_1);
export default default_1;
